import { render, staticRenderFns } from "./AddressView.vue?vue&type=template&id=48e826d6&scoped=true&"
import script from "./AddressView.vue?vue&type=script&lang=ts&"
export * from "./AddressView.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48e826d6",
  null
  
)

export default component.exports